// extracted by mini-css-extract-plugin
export var termsList = "TermsOfUse-module--termsList--v7uQI";
export var termsListBtnActive = "TermsOfUse-module--termsListBtnActive--H6gDB";